import {Card, Col, Row, Typography} from 'antd';

import {Locale} from '../../../../../../provider/locale/locale';
import {AiMonitoringBrandAnalysisType} from '../../../../../../service/ai-brand-monitoring/ai-brand-monitoring-type';

import {PositioningItem} from './positioning-item';

type PropsType = {
    analysis: AiMonitoringBrandAnalysisType;
};

export function PositioningBlock(props: PropsType): JSX.Element {
    const {analysis} = props;
    const {strengths, weaknesses} = analysis.positioning;

    return (
        <Card size="small" title={<Locale stringKey="AI_BRAND_MONITORING__ANALYSIS__POSITIONING_TITLE" />}>
            <Row gutter={[24, 8]}>
                <Col md={12} xs={24}>
                    <Typography.Text strong>
                        <Locale stringKey="AI_BRAND_MONITORING__ANALYSIS__STRENGTHS" />
                    </Typography.Text>
                    {strengths.map((item) => (
                        <PositioningItem isStrength item={item} key={item.text} />
                    ))}
                </Col>
                <Col md={12} xs={24}>
                    <Typography.Text strong>
                        <Locale stringKey="AI_BRAND_MONITORING__ANALYSIS__WEAKNESSES" />
                    </Typography.Text>
                    {weaknesses.map((item) => (
                        <PositioningItem isStrength={false} item={item} key={item.text} />
                    ))}
                </Col>
            </Row>
        </Card>
    );
}
